<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-collage-white-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 510}
    <div id="g-collage-white-xs" class="g-artboard" style="">
      <div style="padding: 0 0 107.5758% 0;"></div>
      <div
        id="g-collage-white-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-white-xs.jpg);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:9.4677%;margin-top:-24.6px;left:87.5811%;margin-left:-54px;width:108px;"
      >
        <p class="g-pstyle0">Jared Leto,</p>
        <p class="g-pstyle0">2023</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:8.2846%;margin-top:-17.4px;left:14.6844%;margin-left:-51.5px;width:103px;"
      >
        <p class="g-pstyle0">Katy Perry,</p>
        <p class="g-pstyle0">2019</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:19.3269%;margin-top:-24.6px;left:14.002%;margin-left:-56.5px;width:113px;"
      >
        <p class="g-pstyle0">Designer:</p>
        <p class="g-pstyle0">Jeremy Scott</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:19.3268%;margin-top:-24.6px;left:88.4319%;margin-left:-42px;width:84px;"
      >
        <p class="g-pstyle0">Designer:</p>
        <p class="g-pstyle0">SCPS</p>
      </div>
      <div
        id="g-ai0-5"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:76.6789%;margin-top:-23.2px;left:1.0868%;width:185px;"
      >
        <p class="g-pstyle1">Lights powered by</p>
        <p class="g-pstyle1">batteries inside the corset</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:91.3403%;margin-top:-23.3px;right:13.128%;width:213px;"
      >
        <p class="g-pstyle2">Costume of Karl Lagerfeld&rsquo;s</p>
        <p class="g-pstyle2">beloved cat, Choupette</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: sm -->
  {#if width && width >= 510 && width < 660}
    <div id="g-collage-white-sm" class="g-artboard" style="">
      <div style="padding: 0 0 84.902% 0;"></div>
      <div
        id="g-collage-white-sm-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-white-sm.jpg);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:7.0774%;margin-top:-20.6px;left:10.8284%;margin-left:-58px;width:116px;"
      >
        <p class="g-pstyle0">Katy Perry,</p>
        <p class="g-pstyle0">2019</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:10.865%;margin-top:-29px;left:89.4416%;margin-left:-61.5px;width:123px;"
      >
        <p class="g-pstyle0">Jared Leto,</p>
        <p class="g-pstyle0">2023</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:18.4862%;margin-top:-29px;left:11.1815%;margin-left:-64px;width:128px;"
      >
        <p class="g-pstyle0">Designer:</p>
        <p class="g-pstyle0">Jeremy Scott</p>
      </div>
      <div
        id="g-ai1-4"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:19.179%;margin-top:-29px;left:89.9318%;margin-left:-47px;width:94px;"
      >
        <p class="g-pstyle0">Designer:</p>
        <p class="g-pstyle0">SCPS</p>
      </div>
      <div
        id="g-ai1-5"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:79.2714%;margin-top:-12.2px;left:1.1915%;width:354px;"
      >
        <p class="g-pstyle1">Lights powered by batteries inside the corset</p>
      </div>
      <div
        id="g-ai1-6"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:92.5637%;margin-top:-23.8px;right:2.1446%;width:244px;"
      >
        <p class="g-pstyle2">Costume of Karl Lagerfeld&rsquo;s</p>
        <p class="g-pstyle2">beloved cat, Choupette</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660 && width < 930}
    <div id="g-collage-white-md" class="g-artboard" style="">
      <div style="padding: 0 0 72.4242% 0;"></div>
      <div
        id="g-collage-white-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-white-md.jpg);"
      ></div>
      <div
        id="g-ai2-1"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:4.6538%;margin-top:-12.2px;left:1.82%;width:150px;"
      >
        <p class="g-pstyle0">Katy Perry, 2019</p>
      </div>
      <div
        id="g-ai2-2"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:6.8295%;margin-top:-20.6px;right:0.6268%;width:162px;"
      >
        <p class="g-pstyle1">Jared Leto, 2023</p>
      </div>
      <div
        id="g-ai2-3"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:11.432%;margin-top:-20.6px;left:1.5822%;width:198px;"
      >
        <p class="g-pstyle0">Designer: Jeremy Scott</p>
      </div>
      <div
        id="g-ai2-4"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:12.478%;margin-top:-20.6px;right:0.6703%;width:147px;"
      >
        <p class="g-pstyle1">Designer: SCPS</p>
      </div>
      <div
        id="g-ai2-5"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:80.5952%;margin-top:-12.2px;left:1.0403%;width:354px;"
      >
        <p class="g-pstyle0">Lights powered by batteries inside the corset</p>
      </div>
      <div
        id="g-ai2-6"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:94.3098%;margin-top:-23.8px;right:0.9316%;width:244px;"
      >
        <p class="g-pstyle2">Costume of Karl Lagerfeld&rsquo;s</p>
        <p class="g-pstyle2">beloved cat, Choupette</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: lg -->
  {#if width && width >= 930 && width < 1200}
    <div id="g-collage-white-lg" class="g-artboard" style="">
      <div style="padding: 0 0 69.3548% 0;"></div>
      <div
        id="g-collage-white-lg-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-white-lg.jpg);"
      ></div>
      <div
        id="g-ai3-1"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:8.2551%;margin-top:-12.2px;left:1.7216%;width:150px;"
      >
        <p class="g-pstyle0">Katy Perry, 2019</p>
      </div>
      <div
        id="g-ai3-2"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:12.8132%;margin-top:-20.6px;left:84.2328%;width:162px;"
      >
        <p class="g-pstyle0">Jared Leto, 2023</p>
      </div>
      <div
        id="g-ai3-3"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:12.9682%;margin-top:-20.6px;left:1.7216%;width:198px;"
      >
        <p class="g-pstyle0">Designer: Jeremy Scott</p>
      </div>
      <div
        id="g-ai3-4"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:16.9992%;margin-top:-20.6px;left:84.2328%;width:151px;"
      >
        <p class="g-pstyle0">Designer: SCPS</p>
      </div>
      <div
        id="g-ai3-5"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:84.9992%;margin-top:-12.2px;left:1.8135%;width:354px;"
      >
        <p class="g-pstyle0">Lights powered by batteries inside the corset</p>
      </div>
      <div
        id="g-ai3-6"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:93.7521%;margin-top:-20.7px;right:14.769%;width:244px;"
      >
        <p class="g-pstyle1">Costume of Karl Lagerfeld&rsquo;s</p>
        <p class="g-pstyle1">beloved cat, Choupette</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: xl -->
  {#if width && width >= 1200}
    <div id="g-collage-white-xl" class="g-artboard" style="">
      <div style="padding: 0 0 51.6667% 0;"></div>
      <div
        id="g-collage-white-xl-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-white-xl.jpg);"
      ></div>
    </div>
  {/if}
</div>

<!-- End ai2html - 2025-05-02 15:13 -->

<!-- Generated by ai2html v0.100.0 - 2025-05-02 15:13 -->
<!-- ai file: collage-white.ai -->
<style lang="scss">
  #g-collage-white-box,
  #g-collage-white-box .g-artboard {
    margin: 0 auto;
  }
  #g-collage-white-box p {
    margin: 0;
  }
  #g-collage-white-box .g-aiAbs {
    position: absolute;
  }
  #g-collage-white-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-collage-white-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-collage-white-xs {
    position: relative;
    overflow: hidden;
  }
  #g-collage-white-xs p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-white-xs .g-pstyle0 {
    height: 14px;
    text-align: center;
  }
  #g-collage-white-xs .g-pstyle1 {
    line-height: 20px;
    height: 20px;
  }
  #g-collage-white-xs .g-pstyle2 {
    line-height: 20px;
    height: 20px;
    text-align: right;
  }
  #g-collage-white-sm {
    position: relative;
    overflow: hidden;
  }
  #g-collage-white-sm p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-white-sm .g-pstyle0 {
    height: 17px;
    text-align: center;
  }
  #g-collage-white-sm .g-pstyle1 {
    height: 17px;
  }
  #g-collage-white-sm .g-pstyle2 {
    line-height: 20px;
    height: 20px;
    text-align: right;
  }
  #g-collage-white-md {
    position: relative;
    overflow: hidden;
  }
  #g-collage-white-md p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-white-md .g-pstyle0 {
    height: 17px;
  }
  #g-collage-white-md .g-pstyle1 {
    height: 17px;
    text-align: right;
  }
  #g-collage-white-md .g-pstyle2 {
    line-height: 20px;
    height: 20px;
    text-align: right;
  }
  #g-collage-white-lg {
    position: relative;
    overflow: hidden;
  }
  #g-collage-white-lg p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-white-lg .g-pstyle0 {
    height: 17px;
  }
  #g-collage-white-lg .g-pstyle1 {
    height: 17px;
    text-align: right;
  }
  #g-collage-white-xl {
    position: relative;
    overflow: hidden;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
